import Controller, { OnAfterFetch } from '@philips-internal/oswald-ui-core/lib/client';
import { FetchEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import BaseController from '../BaseController';
import { cast } from '../../utils/cast-helpers';
import { PrivacyData } from '../../interfaces/privacy-data';
import { AuthenticationService } from '@philips-internal/oswald-ui-core/lib/services';
import Audit from '../../app/audit';
import './index.css';

@Controller({ fragment: 'privacy-modal', component: 'panel-0' })
export default class PrivacyModalController extends BaseController {

  private termData: PrivacyData;

  @OnAfterFetch({ target: 'fetch-data' })
  onFetchPrivacyData(fetchEvent: FetchEvent): void {
    this.termData = cast(fetchEvent.data);
    const body = {
      route: '/terms/privacy',
      functionName: 'Privacy notice ('.concat(this.termData.termSeqNr.toString()).concat(')'),
      'refresh_token': AuthenticationService.getRefreshToken(),
    };

    Audit.functionAccessLog(body);

  }

}
